import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["separator", "container", "className"],
  _excluded2 = ["className"],
  _excluded3 = ["counter"];
import * as React from 'react';
import { useLightboxState, clsx, cssClass, createModule } from '../../index.js';
import { MODULE_CONTROLLER, PLUGIN_COUNTER } from '../../types.js';
const defaultCounterProps = {
  separator: "/",
  container: {}
};
const resolveCounterProps = counter => Object.assign({}, defaultCounterProps, counter);
function CounterComponent(_ref) {
  let {
    counter
  } = _ref;
  const {
    slides,
    currentIndex
  } = useLightboxState();
  const _resolveCounterProps = resolveCounterProps(counter),
    {
      separator,
      container: {
        className
      },
      className: legacyClassName
    } = _resolveCounterProps,
    rest = _objectWithoutPropertiesLoose(_resolveCounterProps.container, _excluded2),
    legacyRest = _objectWithoutPropertiesLoose(_resolveCounterProps, _excluded);
  if (slides.length === 0) return null;
  return /*#__PURE__*/React.createElement("div", Object.assign({
    className: clsx(cssClass("counter"), className || legacyClassName)
  }, legacyRest, rest), currentIndex + 1, " ", separator, " ", slides.length);
}
function Counter(_ref2) {
  let {
    augment,
    addChild
  } = _ref2;
  augment(_ref3 => {
    let {
        counter
      } = _ref3,
      restProps = _objectWithoutPropertiesLoose(_ref3, _excluded3);
    return Object.assign({
      counter: resolveCounterProps(counter)
    }, restProps);
  });
  addChild(MODULE_CONTROLLER, createModule(PLUGIN_COUNTER, CounterComponent));
}
export { Counter as default };